import React from 'react'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { toast } from 'sonner';
import { getMyProfile } from '../../api/api.global';
import { Controls, Player } from '@lottiefiles/react-lottie-player';

const RequestPlan = ({ profileData }) => {

    async function submitContact() {
        loadingShow();
        let resp = await getApi(urlApi.requestPlan);
        loadingHide();
        getMyProfile();
        if (resp.responseCode === 200) {
            toast.success(resp?.message);
        } else {
            toast.error(resp?.message);
        }
    }

    return (
        <>
            <div className="flex flex-1 items-center justify-center rounded-md bg-white flex-wrap gap-6" style={{ height: 'calc( 100vh - 120px )' }}>
                <div className='flex items-center justify-center flex-1'>
                    <Player src={process.env.PUBLIC_URL + "/loading/plan-request.json"} background="rgba(0, 0, 0, 0)" speed="1" loop autoplay style={{ height: 300 }}>
                        <Controls visible={false} />
                    </Player>
                </div>
                <div className='text-center flex-1'>
                    <p className="text-center text-sm font-bold text-gray-500 mb-3">
                        You are not a member of any plan. Please contact us to view this page.
                    </p>
                    <button className="block mx-auto px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-md hover:bg-orange-700 focus:outline-none" disabled={profileData?.planRequestStatus == 2} onClick={() => submitContact()}>
                        {profileData?.planRequestStatus == 2 ? "Already Applied" : "Contact Us Now"}
                    </button>

                    {
                        profileData?.planRequestStatus == 2 && (
                            <div className="mt-4 text-center text-sm font-medium text-gray-500">
                                You have already requested for a plan. We will contact you soon.
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default RequestPlan